<script setup lang="ts">
interface IProps {
  to: string
}

const props = defineProps<IProps>()
</script>

<template>
  <DropdownMenuItem as-child class="main-menu-dropdown-item text-lg">
    <NuxtLinkLocale :to="props.to" class="main-menu-accented-link"><slot /></NuxtLinkLocale>
  </DropdownMenuItem>
</template>
